
@if (showLoading) {
  <app-loading-backdrop></app-loading-backdrop>
}
<router-outlet></router-outlet>
